import { Chip, Icon, LinkButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Stack, useTheme } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountInfoProps as Props } from './types';

export const AccountInfo = memo(
  ({ className, name, link, logo, socialMedia, isInformation }: Props) => {
    const theme = useTheme();

    return (
      <Styled.Wrapper
        className={classnames('AccountInfo', className)}
        sx={SX.root}
      >
        <Avatar src={logo || '/assets/avatar/default-avatar.svg'} size={40} />
        <Stack gap={0.5}>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <Styled.CompanyNameLink to={link}>{name}</Styled.CompanyNameLink>
            {isInformation && (
              <Chip
                label="Active"
                size="small"
                variant="outlined"
                color="success"
                shape="rounded"
              />
            )}
          </Stack>
          <Stack direction="row" spacing={0.5}>
            <LinkButton
              variant="text"
              href={socialMedia.domain}
              sx={{
                lineHeight: 0,
              }}
            >
              <Icon
                color={theme.palette.grey[600]}
                size={16}
                name="link"
                sxx={SX.socialIcon}
              />
            </LinkButton>
            <LinkButton
              variant="text"
              href={socialMedia.facebook}
              sx={{
                lineHeight: 0,
              }}
            >
              <Icon
                color={theme.palette.grey[600]}
                size={16}
                name="facebook"
                sxx={SX.socialIcon}
              />
            </LinkButton>
            <LinkButton
              variant="text"
              href={socialMedia.linkedin || '-'}
              sx={{
                lineHeight: 0,
              }}
            >
              <Icon
                color={theme.palette.grey[600]}
                size={16}
                name="linkedin"
                sxx={SX.socialIcon}
              />
            </LinkButton>
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

AccountInfo.displayName = 'AccountInfo';
